module.exports = __webpack_public_path__ + "img/Faroe-Islands.ff3c01be.png";